export const tabview: any = {
  planets: {
    id: 1,
    label: 'planets',

  },
  citizens: {
    id: 2,
    label: 'citizens',

  },
  volunteers: {
    id: 3,
    label: 'volunteers',

  }
}


export const tabconfig: any = [
  {
    tab: 'planets',
    value: 'Planeten'

  },
  {
    tab: 'citizens',
    value: 'Bewohner'
  },
  {
    tab: 'volunteers',
    value: 'Unterstützer'
  },
]


export const icon_config: any = {
  planets: [

    {
      name: 'delete',
      iconType: 'icons',
      iconColor: "red",
      value: 'delete'
    }
  ], citizens: [
    // {
    //   name: 'visibility',
    //   iconType: 'icons',
    //   iconColor: "rgb(1, 197, 255)",
    //   value: 'visible'
    // },
    {
      name: 'person_remove',
      iconType: 'icons',
      iconColor: "red",
      value: 'remove'
    },
    {
      name: 'person_add_alt',
      iconType: 'icons',
      iconColor: "rgb(1, 197, 255)",
      value: 'add'
    }


  ], volunteers: [


    {
      name: 'favorite_border',
      iconType: 'icons',
      iconColor: "red",
      value: 'un_like'
    },
    {
      name: 'favorite',
      iconType: 'icons',
      iconColor: "red",
      value: 'like'
    },
 
    // {
    //   name: 'volunteer_activism',
    //   iconType: 'symbols',
    //   iconColor: "rgb(1, 197, 255)",
    //   value: 'engage'

    // },
    //  {
    //   name: 'diversity_2',
    //   iconType: 'symbols',
    //   iconColor: "rgb(255, 241, 69)"

    // }
  ]
}


export const table_content: any = {
  planets: {
    img: 'category_image_url',
    name: "pro_name",
    status: "pro_status_name",
    status_id: 'pro_status_id',
    contact_name: 'pro_contact_name',
    email: "pro_contact_email",
    phone: "pro_contact_phone",
    volunteer:'vol_count',
    citizen:'citz_count',
      like:'like_count'

  },
  citizens: {
    img: 'usr_pic_url',
    name: "usr_name",
    status: "orb_status",
    email: "usr_email",
    phone: "usr_phone",
    user_type: 'usr_type',
    planet:'category_image_url',
    planet_name:"pro_name"
  },
  volunteers: {
    img: 'usr_pic_url',
    name: "volunteer_name",
    email: "volunteer_email",
    phone: "volunteer_phone",
    planet:'category_image_url',
    planet_name:"pro_name",
    citizen:"citizen",
    like:'liked'
  }

}

export const table_header = {
  planets: [
    {
      th_name: "planets",
      th_classname: "col-1 pe-3",
    },
    {
      th_name: "name",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "status",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "contact_name",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "contact_email",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "contact_phone",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "citizens",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "volunteers",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "likes",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "action",
      th_classname: "col-2 px-3",
    },
  ],
  citizens: [
    {
      th_name: "person",
      th_classname: "col-1 pe-3",
    },
    {
      th_name: "name",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "status",
      th_classname: "col-1 px-3",
    },
    {
      th_name: "contact_email",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "contact_phone",
      th_classname: "col-1 px-3",
    },
    {
      th_name: "planets",
      th_classname: "col-1 px-3",
    },
    {
      th_name: "planets_name",
      th_classname: "col-3 px-3",
    },
    {
      th_name: "action",
      th_classname: "col-2 px-3 ",
    },
  ],
  volunteers: [
    {
      th_name: "person",
      th_classname: "col-1 pe-3",
    },
    {
      th_name: "name",
      th_classname: "col-2 px-3",
    },
    // {
    //   th_name: "Information",
    //   th_classname: "col-2",
    // },
    {
      th_name: "contact_email",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "contact_phone",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "planets",
      th_classname: "col-1 px-3",
    },
    {
      th_name: "planets_name",
      th_classname: "col-2 px-3",
    },
    {
      th_name: "",
      th_classname: "col-1 px-3",
    },
    {
      th_name: "action",
      th_classname: "col-3 px-3",
    },
  ],
};


export const btnConfig = [
  { label: 'no', value: false },
  { label: 'yes', value: true },
]


export const citizenInActiveBtnConfig = [
  { label: 'no', value: false },
  { label: 'yes', value: true },
]